var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIMapMarkerHit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 55,
    viewBox: "0 0 44 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_488_20178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 2C10.951 2 2 10.9511 2 22C2 26.1758 3.27872 30.052 5.47652 33.2488C5.47652 33.2488 9.49251 39.3626 22 52.7692C34.5275 39.3826 38.5235 33.2488 38.5235 33.2488C40.7213 30.052 42 26.1559 42 22C42 10.9511 33.049 2 22 2Z",
    fill: "#3284FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 2C10.951 2 2 10.9511 2 22C2 26.1758 3.27872 30.052 5.47652 33.2488C5.47652 33.2488 9.49251 39.3626 22 52.7692C34.5275 39.3826 38.5235 33.2488 38.5235 33.2488C40.7213 30.052 42 26.1559 42 22C42 10.9511 33.049 2 22 2Z",
    stroke: "white",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7132 23.1231C33.0315 20.8049 33.0315 17.0462 30.7132 14.7279C28.395 12.4096 24.6363 12.4096 22.318 14.7279L14.1086 22.9373C11.7904 25.2555 11.7904 29.0142 14.1086 31.3325C16.4269 33.6508 20.1856 33.6508 22.5039 31.3325L30.7132 23.1231Z",
    stroke: "white",
    strokeWidth: 1.32731,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2188 18.832L14.1141 22.9367C11.7984 25.2524 11.7984 29.0163 14.1141 31.332C16.4297 33.6476 20.1936 33.6476 22.5093 31.332L26.614 27.2273L18.2188 18.832Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.32731,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_488_20178",
    x: 0.357143,
    y: 0.357143,
    width: 43.2857,
    height: 54.0549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.571429
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_488_20178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_488_20178",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIMapMarkerHit);
export default __webpack_public_path__ + "static/media/i_map_marker_hit.97ec7c70640db6a33d270d7ba8b7a29f.svg";
export { ForwardRef as ReactComponent };